import { COLUMNS, FOLLOW_UP_GROUPS, FOLLOW_UP_GROUP_BY_COLUMN } from "../model/materielConstants";
import { tdStyle, thStyle } from "./materielStyles";

// En-têtes groupés et colonnes épinglées du tableau de suivi, avec la couleur choisie pour chaque colonne.
export const followUpGroupHeaderStyle = group => ({
    position: "sticky",
    top: 0,
    zIndex: 3,
    height: "34px",
    padding: "8px 10px",
    background: group.header,
    borderRight: `1px solid ${group.border}`,
    color: "white",
    fontSize: "11px",
    fontWeight: 800,
    textAlign: "center",
    textTransform: "uppercase",
});
export const followUpPinnedHeaderStyle = (column, index, columnColors, selectedColumn) => ({
    ...thStyle,
    top: 0,
    left: index === 0 ? 0 : COLUMNS[0].width,
    zIndex: 6,
    width: column.width,
    minWidth: column.width,
    boxSizing: "border-box",
    background: columnColors[column.key] || FOLLOW_UP_GROUPS[0].subHeader,
    borderRight: `1px solid ${FOLLOW_UP_GROUPS[0].border}`,
    color: "#111827",
    outline: selectedColumn === column.key ? "3px solid #2563eb" : "none",
    outlineOffset: "-3px",
    boxShadow: index === 1 ? "3px 0 5px rgba(15, 23, 42, 0.12)" : "none",
});
export const followUpHeaderStyle = (column, index, columnColors, selectedColumn) => ({
    ...thStyle,
    top: "34px",
    background: columnColors[column.key] || FOLLOW_UP_GROUP_BY_COLUMN[column.key].subHeader,
    borderRight: `1px solid ${FOLLOW_UP_GROUP_BY_COLUMN[column.key].border}`,
    color: "#111827",
    outline: selectedColumn === column.key ? "3px solid #2563eb" : "none",
    outlineOffset: "-3px",
    width: column.width,
    minWidth: column.width,
    boxSizing: "border-box",
    ...(index < 2 ? {
        left: index === 0 ? 0 : COLUMNS[0].width,
        zIndex: 4,
        boxShadow: index === 1 ? "3px 0 5px rgba(15, 23, 42, 0.08)" : "none",
    } : {}),
});
export const followUpCellStyle = (row, index, columnColors, selectedColumn) => ({
    ...tdStyle,
    minWidth: COLUMNS[index].width,
    boxSizing: "border-box",
    background: row.notInvoiced
        ? "#fee2e2"
        : columnColors[COLUMNS[index].key] || FOLLOW_UP_GROUP_BY_COLUMN[COLUMNS[index].key].cell,
    borderRight: `1px solid ${FOLLOW_UP_GROUP_BY_COLUMN[COLUMNS[index].key].border}`,
    boxShadow: selectedColumn === COLUMNS[index].key
        ? "inset 2px 0 #2563eb, inset -2px 0 #2563eb"
        : index === 1 ? "3px 0 5px rgba(15, 23, 42, 0.08)" : "none",
    ...(index < 2 ? {
        position: "sticky",
        left: index === 0 ? 0 : COLUMNS[0].width,
        zIndex: 2,
        boxShadow: selectedColumn === COLUMNS[index].key
            ? "inset 2px 0 #2563eb, inset -2px 0 #2563eb"
            : index === 1 ? "3px 0 5px rgba(15, 23, 42, 0.08)" : "none",
    } : {}),
});
